"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntegrationKeyOut = void 0;
class IntegrationKeyOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return IntegrationKeyOut.attributeTypeMap;
    }
}
exports.IntegrationKeyOut = IntegrationKeyOut;
IntegrationKeyOut.discriminator = undefined;
IntegrationKeyOut.attributeTypeMap = [
    {
        "name": "key",
        "baseName": "key",
        "type": "string",
        "format": ""
    }
];
//# sourceMappingURL=IntegrationKeyOut.js.map